<template>
  <div class="tab_match">
    <!-- 动态菜单 -->
    <div class="match_menu">
      <li class="item com_link" v-for="(v,i) in refList" :key="i">
        <span @click="scrollInto(v.refName)">{{v.name}}</span>
      </li>
    </div>
    <!-- 种类循环 -->
    <div ref="cateBox">
      <div :ref="'cateRef'+conIndex" class="cate_content" v-for="(conItem, conIndex) in allData.categoryDetailList" :key="conIndex">
        <div class="com_title">
          <div class="left">
            <div class="title_img_box">
              <img v-lazy="conItem.addInFilePath" alt='图片加载失败'>
            </div>
            <span class="line"></span>
            <span class="test">{{ conItem.name }}</span>
          </div>
          <div class="right com_link">
            <router-link :to="{path:'/category',query: { categorySerNo: conItem.serNo }}" target="_blank">更多>></router-link>
          </div>
        </div>
        <div class="com_item">
          <!-- 内容 -->
          <div class="item" v-for="(item, index) in conItem.mixList" :key="index" v-show="index<4">
            <h3 class="title com_hidden">
              <router-link :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
                <span class="com_link">{{item.mixName}}</span>
              </router-link>
            </h3>
            <div class="sprice" style="padding:4px 0px 0px;">
              市场参考价：
              <span class="line_th">￥{{ item.salePrice | priceValue }}</span>
            </div>
            <div class="price">
              <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">整装拎包价￥{{ item.clientSalePrice | priceValue}}</p>
              <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
            </div>
            <router-link class="img_box mask" :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
              <img v-lazy="item.mainPreviewImageFilePath" alt='图片加载失败' />
            </router-link>
            <div class="itr_box">
              <p class="itr com_hidden">
                <router-link :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
                  产品规格：{{item.attr1ContentName+' '+item.attr2ContentName+' '+item.attr3ContentName+' '+item.attr4ContentName}}
                </router-link>
              </p>
              <p class="itr com_hidden" v-if="item.mixGoodsLength && item.mixGoodsWidth && item.mixGoodsHeight">
                <span>尺寸：{{item.mixGoodsLength+'mm*'+item.mixGoodsWidth+'mm*'+item.mixGoodsHeight+'mm'}}</span>
              </p>
              <p class="itr com_hidden">
                <span>编码：{{item.mixNo}}</span>
              </p>
              <p>
                <span>购买数量：</span>
                <el-input-number v-model="item.goodsCount" controls-position="right" :min="0" :max="999" size="mini"></el-input-number>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 丰富区 -->
    <div class="more_goods" v-if="false">
      <h4 class="more_title">丰富区</h4>
      <p class="more_test">MATCHING AREA</p>
      <div class="more_item">
        <div class="item" v-for="(item, index) in allData.moreDetailList" :key="index" v-show="index<moreLength">
          <router-link class="img_box mask" :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
            <img v-lazy="item.mainPreviewImageFilePath" alt='图片加载失败' />
          </router-link>
          <div class="itr_box">
            <div class="itr_title">
              <p class="com_link com_hidden">
                <router-link :to="{path:'/category',query: { categorySerNo: item.categorySerNo }}" target="_blank">{{item.categoryName}}</router-link>
              </p>
              <p>￥{{item.salePrice | priceValue}}</p>
            </div>
            <p class="itr com_hidden">
              <router-link :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
                产品规格：{{item.attr1ContentName+' '+item.attr2ContentName+' '+item.attr3ContentName+' '+item.attr4ContentName}}
              </router-link>
            </p>
            <p class="itr com_hidden" v-if="item.mixGoodsLength && item.mixGoodsWidth && item.mixGoodsHeight">
              <span>尺寸：{{item.mixGoodsLength+'mm*'+item.mixGoodsWidth+'mm*'+item.mixGoodsHeight+'mm'}}</span>
            </p>
            <p class="itr com_hidden">
              <span>编码：{{item.mixNo}}</span>
            </p>
            <p>
              <span>购买数量：</span>
              <el-input-number v-model="item.goodsCount" controls-position="right" :min="0" :max="999" size="mini"></el-input-number>
            </p>
          </div>
        </div>
      </div>
      <div class="btn_box" v-if="allData.moreDetailList.length>8">
        <el-button class="btn" type="primary" @click="moreLength==8?moreLength=allData.moreDetailList.length:moreLength=8">
          <span>{{moreLength==8?'点击加载更多':'点击收起'}}</span>
          <i class="myicon iconfont" :class="moreLength==8?'icon-gengduo':'icon-shouqi'"></i>
        </el-button>
      </div>
    </div>
    <div :class="{footer:true,fixed:isFixed}">
      <!-- <div class="export" @click="exportDetail">
        <i class="myicon iconfont icon-daochu1"></i>
        <span>导出套餐</span>
      </div> -->
      <div class="select">已选 <span class="f30">{{selectNumber}}</span> 件</div>
      <div class="price">整装拎包优惠价：
        <span class="fwb">￥</span>
        <span class="f30">{{$cookies.isKey('ACCESS_TOKEN')?tokenSelectPrice:selectPrice}}</span>
      </div>
      <el-button class="btn" type="primary" @click="goPlaceOrder">购物车结算</el-button>
    </div>
    <dialog-login ref="diaLogin" @updateLogin="updateLogin"></dialog-login>
  </div>
</template>

<script>
import { GetGoodsWholeThemeDetailByNo } from "@/pages/page1/api/modules/home";
import { BatchAddShopCart } from "@/pages/page1/api/modules/shoppingCart";
import DialogLogin from "@/pages/page1/components/dialogLogin.vue";
export default {
  components: { DialogLogin },
  props: {
    footerHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      refList: [],
      moreLength: 8,
      allData: {
        themeInfo: {}, //主题信息
        categoryDetailList: [], //分类列表
        moreDetailList: [], //丰富区
      },
      isFixed: false,
    };
  },
  mounted() {
    this.getGoodsWholeThemeDetailByNo(this.$route.query.themeNo);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getGoodsWholeThemeDetailByNo(themeNo) {
      this.refList = [];
      GetGoodsWholeThemeDetailByNo({ themeNo }).then((res) => {
        // console.log("获取搭配商品", res);
        this.allData = res.data[0];
        // 处理数据
        this.allData.categoryDetailList.forEach((item, index) => {
          item.mixList = item.mixList.splice(0, 4);
          this.actionAttr(item.mixList);
          this.refList.push({
            name: item.name,
            refName: "cateRef" + index,
          });
        });
        this.actionAttr(this.allData.moreDetailList);
      });
    },
    // 处理数据
    actionAttr(arr) {
      arr.forEach((item) => {
        this.$set(item, "goodsCount", item.addInMixCount);
        this.$set(item, "goodsMixId", item.id);
        if (!item.attr1ContentName) {
          item.attr1ContentName = "";
        }
        if (!item.attr2ContentName) {
          item.attr2ContentName = "";
        }
        if (!item.attr3ContentName) {
          item.attr3ContentName = "";
        }
        if (!item.attr4ContentName) {
          item.attr4ContentName = "";
        }
      });
    },
    goPlaceOrder() {
      if (this.selectBrands.length === 0) {
        this.$alert("请至少选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let params = {
          regionCode: localStorage.getItem("_regionCode"),
          shoppingCartList: this.cartList,
        };
        BatchAddShopCart(params).then((res) => {
          // console.log("批量加入购物车", res);
          // 用购物车id代替原本id
          let newBusiness = JSON.parse(JSON.stringify(this.selectBrands));
          newBusiness.forEach((item) => {
            item.shoppingCartList.forEach((v) => {
              let resItem = res.data.find((j) => j.goodsMixId === v.goodsMixId);
              if (resItem) {
                v.id = resItem.id;
                v.goodsCount = resItem.goodsCount;
              }
            });
          });
          // console.log(this.selectBrands,newBusiness);
          // return
          // 选中的商品去订单生成
          let time = new Date().getTime();
          localStorage.setItem(
            "selectGoods_" + time,
            JSON.stringify(newBusiness)
          );
          let newUrl = this.$router.resolve({
            path: "/placeOrder",
            query: { id: time, byUrl: "shopCart" },
          });
          window.open(newUrl.href, "_self");
        });
      } else {
        this.$refs.diaLogin.elVisible = true;
      }
    },
    updateLogin(isLogin) {
      if (isLogin) {
        location.reload();
      }
    },
    // 吸底
    handleScroll() {
      // 内容可视区域的高度加上溢出上下（滚动）的距离
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 可视高度
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 页面被卷去的上高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 页面被卷去的下高度
      let scrollBottom = scrollHeight - clientHeight - scrollTop;
      // 底部footer高度+margin +误差
      let footerHeight = this.footerHeight + 90;
      // console.log(scrollBottom, footerHeight);
      scrollBottom <= footerHeight
        ? (this.isFixed = false)
        : (this.isFixed = true);
      if (scrollTop <= 240) {
        this.isFixed = false;
      }
    },
    scrollInto(refName) {
      let element;
      // 循环出来的在数组
      if (this.$refs[refName][0]) {
        element = this.$refs[refName][0];
      } else {
        element = this.$refs[refName];
      }
      // 不带对象参数兼容性好
      element.scrollIntoView();
    },
    exportDetail() {
      console.log(1);
    },
  },
  computed: {
    selectGoods() {
      let arr = [];
      this.allData.categoryDetailList.forEach((item) => {
        item.mixList.forEach((v) => {
          if (v.goodsCount > 0) {
            arr.push(v);
          }
        });
      });
      // this.allData.moreDetailList.forEach((item) => {
      //   if (item.goodsCount > 0) {
      //     arr.push(item);
      //   }
      // });
      return arr;
    },
    cartList() {
      let arr = [];
      this.selectGoods.forEach((item) => {
        arr.push({
          goodsMixId: item.goodsMixId,
          goodsCount: item.goodsCount,
        });
      });
      return arr;
    },
    selectNumber() {
      let num = 0;
      this.selectGoods.forEach((item) => {
        num += item.goodsCount;
      });
      return num;
    },
    // 未登录
    selectPrice() {
      let num = 0;
      this.selectGoods.forEach((item) => {
        num += item.goodsCount * item.salePrice;
      });
      return num;
    },
    // 登录后
    tokenSelectPrice() {
      let num = 0;
      this.selectGoods.forEach((item) => {
        num += item.goodsCount * item.clientSalePrice;
      });
      return num;
    },
    selectBrands() {
      let brandArr = [];
      // 品牌合并
      this.selectGoods.forEach((item) => {
        let resItem = brandArr.find((v) => v.goodsBrandId === item.brandId);
        if (!resItem) {
          brandArr.push({
            goodsBrandId: item.brandId,
            goodsBrandName: item.brandName,
            shoppingCartList: [],
          });
        }
      });
      // 每个品牌下面的商品
      brandArr.forEach((item) => {
        this.selectGoods.forEach((v) => {
          if (item.goodsBrandId == v.brandId) {
            item.shoppingCartList.push(v);
          }
        });
      });
      return brandArr;
    },
  },
};
</script>

<style lang="less" scoped>
.tab_match {
  margin-bottom: 144px;
  padding-top: 48px;
  position: relative;
  .match_menu {
    padding-bottom: 24px;
    border-bottom: 1px solid #333333;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .item {
      font-size: 18px;
      margin-right: 30px;
      line-height: 30px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .cate_content {
    .com_title {
      width: 100%;
      height: 74px;
      box-sizing: border-box;
      padding: 0 6px;
      line-height: 74px;
      display: flex;
      justify-content: space-between;
      .left {
        font-size: 20px;
        display: flex;
        align-items: center;
        .title_img_box {
          width: 35px;
          height: 35px;
          overflow: hidden;
          display: flex;
          align-items: center;
          img {
            height: auto;
            max-height: 100%;
          }
        }
        .line {
          display: inline-block;
          width: 1px;
          height: 16px;
          background-color: #1a1a1a;
          margin: 0 20px;
        }
      }
      .right {
        font-size: 14px;
        a {
          color: #1a1a1a;
        }
      }
    }
    .com_item {
      width: 100%;
      height: 480px;
      padding: 0 30px;
      box-sizing: border-box;
      background: #f4f4f4;
      display: flex;
      overflow: hidden;
      .item {
        width: calc((100% - 90px) / 4);
        height: 100%;
        box-sizing: border-box;
        padding-top: 10px;
        margin-right: 30px;
        &:last-child {
          margin-right: 0;
        }
        .title {
          font-size: 18px;
          font-weight: bold;
          line-height: 30px;
          height: 30px;
          a {
            color: #000000;
          }
        }
        .price {
          font-size: 16px;
          font-weight: bold;
          color: #ff0000;
          margin-bottom: 4px;
        }
        .img_box {
          display: block;
          width: 100%;
          height: 260px;
          margin-bottom: 10px;
        }
        .itr_box {
          color: #525252;
          font-size: 12px;
          line-height: 24px;
          .itr {
            height: 24px;
            a {
              color: #525252;
            }
          }
        }
      }
    }
  }
  .more_goods {
    margin-top: 43px;
    width: 100%;
    background: #f4f4f4;
    box-sizing: border-box;
    padding: 47px 30px 32px;
    text-align: center;
    .more_title {
      font-size: 20px;
      font-weight: 800;
    }
    .more_test {
      font-size: 16px;
      font-weight: 500;
      color: #525252;
      padding: 18px 0 28px;
    }
    .more_item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      .item {
        width: calc((100% - 90px) / 4);
        height: 430px;
        box-sizing: border-box;
        margin-right: 30px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .img_box {
          display: block;
          width: 100%;
          height: 260px;
          margin-bottom: 10px;
        }
        .itr_box {
          color: #525252;
          font-size: 12px;
          line-height: 24px;
          .itr_title {
            font-size: 16px;
            font-weight: 800;
            height: 24px;
            display: flex;
            justify-content: space-between;
            a {
              color: #525252;
            }
          }
          .itr {
            height: 24px;
            a {
              color: #525252;
            }
          }
        }
      }
    }
    .btn_box {
      text-align: center;
      .btn {
        width: 284px;
        height: 47px;
        border-radius: 0;
        font-size: 16px;
        .myicon {
          font-size: 16px;
        }
      }
    }
  }
  .footer {
    width: @themeWidth;
    height: 90px;
    box-sizing: border-box;
    padding-left: 30px;
    background: #e4e4e4;
    display: flex;
    align-items: center;
    font-weight: 500;
    z-index: 3;
    position: absolute;
    bottom: -90px;
    left: auto;
    .export {
      font-size: 20px;
      font-weight: 500;
      margin-right: 350px;
      cursor: pointer;
      &:hover {
        color: @themeColor;
        .myicon {
          color: @themeColor;
        }
      }
      .myicon {
        font-size: 20px;
        color: #333333;
        padding-right: 16px;
      }
    }
    .select {
      font-size: 20px;
      color: #1a1a1a;
    }
    .fwb {
      font-weight: bold;
    }
    .f30 {
      font-size: 30px;
      font-weight: bold;
    }
    .price {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 200px;
      color: #f51616;
      font-size: 20px;
    }
    .btn {
      position: absolute;
      right: 0px;
      top: 0px;
      width: 180px;
      height: 100%;
      border-radius: 0;
      font-size: 20px;
    }
  }
  .fixed {
    position: fixed;
    bottom: 0px;
  }
  .mask {
    position: relative;
    cursor: pointer;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>